import { memo, useMemo } from 'react'
import { RaContainer } from '@components/core/index.core'
import { Loop } from '@utilities/helpers/core.helpers'

import { AcfInspirationBlock, AcfInspirationBlocksProps } from '@typings'

import styles from './acf-inspiration-blocks.module.scss'

import { CardLazyWrapper } from '@components/cards/RaCardLazyWrapper/RaCardLazyWrapper'

export const AcfInspirationBlocks = memo(
  ({ blocks }: AcfInspirationBlocksProps) => {
    const cards = useMemo(() => {
      if (!blocks) return null

      return Loop(blocks, (item: AcfInspirationBlock, i: number) => (
        <CardLazyWrapper
          renderCard="inspiration"
          key={i}
          {...{ props: item }}
        />
      ))
    }, [blocks])

    return (
      <RaContainer>
        <div className={styles['acf-inspiration-blocks']}>{cards}</div>
      </RaContainer>
    )
  }
)

AcfInspirationBlocks.displayName = 'AcfInspirationBlocks'
